module.exports = __webpack_public_path__ + "static/media/carousel6.02f6e5d9.jpeg";